import type { PokerPowerPathState } from './types';

export const defaultState: PokerPowerPathState = {
  isLoading: false,
  hasDataError: false,
  steps: {
    step1: null,
    step2SNG: null,
    step2Scheduled: null,
    step3: null,
    step4: null
  },
  passesData: null,
  passesError: ''
};
